// import { TanStackDevtools } from '@tanstack/react-devtools';
// import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
// import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';

// export function Devtools() {
//     return (
//         <TanStackDevtools
//             config={{
//                 hideUntilHover: true,

//             }}
//             plugins={[
//                 {
//                     name: 'Router',
//                     render: <TanStackRouterDevtoolsPanel />,
//                 },
//                 {
//                     name: 'Query',
//                     render: <ReactQueryDevtoolsPanel />,
//                 },
//             ]}
//         />
//     );
// }

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Suspense, useEffect, useState } from 'react';

import { logger } from '@/lib/logger';

declare global {
    // eslint-disable-next-line ts/consistent-type-definitions
    interface Window {
        toggleDevtools: () => void;
    }
}

function getDevtoolsState(): boolean {
    if (typeof window === 'undefined')
        return false;
    if (window?.localStorage?.getItem('devtools') === 'true')
        return true;
    return false;
}

function setDevtoolsState(show: boolean) {
    localStorage.setItem('devtools', JSON.stringify(show));
}

export function Devtools() {
    const [show, setShow] = useState(() => getDevtoolsState());

    useEffect(() => {
        window.toggleDevtools = () => {
            const newState = !show;
            setShow(newState);

            logger.info(`Devtools are now ${newState ? 'shown' : 'hidden'}`);
        };
    }, [show]);

    useEffect(() => setDevtoolsState(show), [show]);

    if (show) {
        return (
            <Suspense fallback={null}>
                <TanStackRouterDevtools />
                <ReactQueryDevtools />
            </Suspense>
        );
    }

    return null;
}
